module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/0e272d26fafc17b602c576327543b9ce.png";